var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./FaqContent.jinja');
require('./FaqContent.less');

var CommonVideoPlayer = require('front/components/CommonVideoPlayer/CommonVideoPlayer');

module.exports = Base.extend({

    template: template,

    events: {
        'click .FaqContent-faqQuestionText': 'onFaqQuestionClick'
    },

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'CommonVideoPlayer': {selector: '.CommonVideoPlayer', viewConstructor: CommonVideoPlayer}
    },


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'proceedUrl');

        this.firstTime = true;

        Base.prototype.initialize.call(this, options);
    },


    activate: function () {
        if (!location.hash.slice(1) && this.$el.hasClass('FaqContent--noCategories')) {
            window.location.hash = '#' + this.$('.FaqContent-faqCategory').eq(0).attr('data-slug');
        }

        this.proceedUrl();

        $(window).on('hashchange', this.proceedUrl);

        return Base.prototype.activate.call(this);
    },


    deactivate: function (params) {
        $(window).off('hashchange', this.proceedUrl);

        return Base.prototype.deactivate.call(this, params);
    },


    showCategory: function (category, defaultCategory) {
        var $category = this.$('.FaqContent-faqCategory[data-slug="' + category + '"]');

        if (!$category.length) {
            if (!app.isPhoneLayout()) {
                $category = this.$('.FaqContent-faqCategory[data-slug="' + defaultCategory + '"]');
                category = defaultCategory;
            } else {
                this.$('.FaqContent-faqCategory').removeClass('FaqContent-faqCategory--active');
                this.$('.FaqContent-faqRightCategories').removeClass('FaqContent-faqRightCategories--active');
                this.$('.FaqContent-faqBack').fadeOut(400);
                this.$('.FaqContent-faqLeft').removeClass('FaqContent-faqLeft--moveout');

                return;
            }
        }

        this.$('.FaqContent-faqCategory').removeClass('FaqContent-faqCategory--active');
        $category.addClass('FaqContent-faqCategory--active');

        this.$('.FaqContent-faqRightCategories').removeClass('FaqContent-faqRightCategories--active');
        this.$('.FaqContent-faqRightCategories[data-slug="' + category + '"]').addClass('FaqContent-faqRightCategories--active');

        if (app.isPhoneLayout()) {
            this.$('.FaqContent-faqBack').fadeIn(400);

            this.$('.FaqContent-faqLeft').addClass('FaqContent-faqLeft--moveout');

            //!this.preventScrollTop && app.animateWindowScroll(this.$('.FaqContent-faq').offset().top);
        }
    },


    expandQuestion: function (question) {
        var $question = this.$('.FaqContent-faqQuestion[data-slug="' + question + '"]');

        if (!$question.length) {
            return;
        }

        $question.addClass('FaqContent-faqQuestion--active');

        $question.find('.FaqContent-faqQuestionRolled').slideDown(200);
    },


    onFaqQuestionClick: function (e) {
        var $question = $(e.target).closest('.FaqContent-faqQuestion');

        this.preventScrollTop = true;

        setTimeout(function () {
            this.preventScrollTop = false;
        }.bind(this), 100);

        if ($question.hasClass('FaqContent-faqQuestion--active')) {
            $question.find('.FaqContent-faqQuestionRolled').slideUp(200);
            $question.removeClass('FaqContent-faqQuestion--active');
            window.location.hash = '#' + $(e.target)
                .closest('.FaqContent-faqRightCategories')
                .attr('data-slug');
            e.preventDefault();
        }
    },


    proceedUrl: function (params) {
        var hash = location.hash.slice(1);

        if (!hash) {
            var previewHash = window.app.preview && window.app.preview.split('#').pop();
            if (previewHash) {
                hash = previewHash;
            }
        }

        var defaultCategory = this.$('.FaqContent-faqCategory')
            .eq(0)
            .attr('data-slug');

        var params = hash.split('/');

        //disable animation
        if (this.firstTime) {
            this.$('.FaqContent-faq').hide();
        }

        this.showCategory(params[0], defaultCategory);

        if (params.length == 2) {
            this.expandQuestion(params[1]);
        }

        //disable animation
        if (this.firstTime) {
            this.$('.FaqContent-faq').outerHeight();
            this.$('.FaqContent-faq').show();
        }

        this.firstTime = false;
    }

});


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/FaqContent/FaqContent.js
// module id = 67
// module chunks = 0